import { AuthUserPermission, Can } from '@cibo/profile'
import { useCiboAutoForm } from '@cibo/ui'
import { Box } from '@mui/material'
import { debugSx } from '@cibo/ui'

export const CiboAutoFormDebugger = () => {
  const form = useCiboAutoForm()

  return (
    <Can useAny={AuthUserPermission.DEBUG_USER}>
      <Box
        component="pre"
        sx={{ textAlign: 'left', mt: 2, p: 1, ...debugSx }}
        data-testid="cibo-auto-form-debugger"
      >
        {JSON.stringify({ model: form.model, error: form.error, warnings: form.warnings }, null, 2)}
      </Box>
    </Can>
  )
}
